// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__10k2E","productName":"Table_productName__3EK18"};